import createHmac from 'create-hmac';
import { getRandomString } from './text';

export function getHashKeys(string, salt = null, includeExtra = true) {
    if(!salt) {
        salt = getRandomString();
    }
    const toHash = `${includeExtra ? process.env.NODE_ENV : ''}${includeExtra ? salt : ''}${string}`;
    const key = createHmac('sha256', salt)
        .update(toHash)
        .digest('hex');
    return {
        salt,
        key,
    };
}
